import '../assets/NcFormBoxButton-BlS280R1.css';
import { reactive, getCurrentInstance, computed, defineComponent } from "vue";
import { n as mdiOpenInNew, o as mdiArrowTopRight } from "./mdi-DkJglNiS.mjs";
import { toRef } from "@vueuse/core";
import { N as NcFormBoxItem } from "./NcFormBoxItem-Bz-P0lVG.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-Bui9PhAS.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
function useButtonLink(options) {
  const props = reactive(options);
  const instance = getCurrentInstance();
  const hasVueRouterContext = "$router" in instance.proxy.$root;
  const tag = computed(() => {
    if (hasVueRouterContext && props.to) {
      return "RouterLink";
    } else if (props.href) {
      return "a";
    } else {
      return "button";
    }
  });
  const isLink = computed(() => tag.value === "RouterLink" || tag.value === "a");
  const isHyperLink = computed(() => tag.value === "a");
  const isRouterLink = computed(() => tag.value === "RouterLink");
  const isButton = computed(() => tag.value === "button");
  const attrs = computed(() => {
    if (tag.value === "RouterLink") {
      return {
        to: props.to,
        activeClass: "active",
        ...props.additionalAttrs?.("RouterLink") ?? {}
      };
    } else if (tag.value === "a") {
      return {
        href: props.href,
        target: props.target,
        download: props.download || void 0,
        rel: "nofollow noreferrer noopener",
        ...props.additionalAttrs?.("a") ?? {}
      };
    } else if (tag.value === "button") {
      return {
        type: props.type || "button",
        disabled: props.disabled,
        ...props.additionalAttrs?.("button") ?? {}
      };
    }
  });
  return {
    tag,
    isLink,
    isHyperLink,
    isRouterLink,
    isButton,
    attrs
  };
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcFormBoxButton",
  props: {
    label: { default: void 0 },
    description: { default: void 0 },
    invertedAccent: { type: Boolean, default: false },
    to: { default: void 0 },
    href: { default: void 0 },
    target: { default: void 0 },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props) {
    const props = __props;
    const { tag, attrs, isLink } = useButtonLink({
      to: toRef(() => props.to),
      href: toRef(() => props.href),
      target: toRef(() => props.target),
      disabled: toRef(() => props.disabled)
    });
    const icon = computed(() => {
      if (isLink.value) {
        return props.target === "_blank" ? mdiOpenInNew : mdiArrowTopRight;
      }
      return void 0;
    });
    return { __sfc: true, props, tag, attrs, isLink, icon, NcFormBoxItem, NcIconSvgWrapper };
  }
});
const formBoxButton = "_formBoxButton_DGIeJ";
const style0 = {
  "material-design-icon": "_material-design-icon_nhhXo",
  formBoxButton
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcFormBoxItem, _vm._b({ attrs: { "tag": _setup.tag, "item-classes": [
    "button-vue",
    /* Reset server's global HTML button styles */
    _vm.$style.formBoxButton
  ], "inverted-accent": _vm.invertedAccent, "tabindex": "0" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } }, scopedSlots: _vm._u([_vm.$scopedSlots.default || _vm.label ? { key: "default", fn: function() {
    return [_vm._t("default", function() {
      return [_vm._v(" " + _vm._s(_vm.label) + " ")];
    })];
  }, proxy: true } : null, _vm.$scopedSlots.description || _vm.description ? { key: "description", fn: function() {
    return [_vm._t("description", function() {
      return [_vm._v(" " + _vm._s(_vm.description) + " ")];
    })];
  }, proxy: true } : null, _vm.$scopedSlots.icon || _setup.icon ? { key: "icon", fn: function() {
    return [_vm._t("icon", function() {
      return [_setup.icon ? _c(_setup.NcIconSvgWrapper, { attrs: { "path": _setup.icon, "inline": "" } }) : _vm._e()];
    })];
  }, proxy: true } : null], null, true) }, "NcFormBoxItem", _setup.attrs, false));
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcFormBoxButton = __component__.exports;
export {
  NcFormBoxButton as N
};
//# sourceMappingURL=NcFormBoxButton-CFWCJ0-X.mjs.map
